
export enum PreviewMode {
	SENTENCES = 'sentences',
	SENTENCES_WITH_CONTEXT = 'sentencesWithContext',
	VERBATIM = 'verbatim',
	DOCUMENT = 'document'
}

